/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Contactposition_Label1Inputs */

const en_company_registration_contactposition_label1 = /** @type {(inputs: Company_Registration_Contactposition_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const de_company_registration_contactposition_label1 = /** @type {(inputs: Company_Registration_Contactposition_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Company_Registration_Contactposition_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_registration_contactposition_label1 = /** @type {((inputs?: Company_Registration_Contactposition_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Contactposition_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_contactposition_label1(inputs)
	return en_company_registration_contactposition_label1(inputs)
});
export { company_registration_contactposition_label1 as "company_registration_contactPosition_label" }